module.exports = __webpack_public_path__ + "static/img/iphone-pizza.c001a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dominos-assets/iphone-pizza.png
// module id = HYx3
// module chunks = 0